module.exports = __webpack_public_path__ + "img/video5.7f68d7cd.jpg";